module.exports = __webpack_public_path__ + "img/1569358205.4934ede8.jpg";